export const normalizeOptionName = (type, name) => {
  const trimmed = (name ?? "").trim();
  return type === "role" ? trimmed.toUpperCase() : trimmed;
};

export const buildCreateOptionPayload = (type, name) => {
  const normalizedName = normalizeOptionName(type, name);
  return {
    type,
    name: normalizedName,
    description: normalizedName,
  };
};

export const buildUpdateOptionPayload = (editingOption, editedName) => {
  if (!editingOption) {
    return null;
  }

  const normalizedName = normalizeOptionName(editingOption.type, editedName);
  return {
    optionsId: editingOption.optionsId,
    description: normalizedName,
    type: editingOption.type,
  };
};

export const isNonEmptyName = (name) => Boolean((name ?? "").trim());
